import { render, staticRenderFns } from "./EditAccessModal.vue?vue&type=template&id=bdfba614&"
import script from "./EditAccessModal.vue?vue&type=script&lang=js&"
export * from "./EditAccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports